import type { TreeApi } from "@hogartrabe/react-arborist-vrh";
import type { Node } from "interfaces/schemas";
import { walkTree } from "utils/treeUtils/walkTree";
import { nodeTypes } from "variables/nodeTypes";

export const collapseAll = (treeApi: TreeApi<Node>) => {
  if (!treeApi) {
    throw new Error("Tree API is not available. Cannot collapse level.");
  }
  treeApi.closeAll();

  const rootNode = treeApi.root.children?.[0];

  if (!rootNode) {
    throw new Error("Root node is missing. Cannot collapse level.");
  }
  treeApi.open(rootNode);

  const newMap: Record<string, boolean> = {};
  walkTree({
    node: rootNode,
    childAccessor: (node) => node.children,
    callback: (node) => {
      if (node.data.kind !== nodeTypes.ROOT) {
        newMap[node.data.id!] = false;
      }
    },
  });
  return newMap;
};
